import { aroFetch } from "../aroApi";
import { AuditListResponse, AuditSearchParams } from "../../types/aro";

export async function fetchAuditLog(params: AuditSearchParams): Promise<AuditListResponse> {
  const qs = new URLSearchParams();
  if (params.record_id)                                          qs.set("record_id",  params.record_id);
  if (params.table_name && params.table_name !== "all")          qs.set("table_name", params.table_name);
  qs.set("limit",  String(params.limit  ?? 100));
  qs.set("offset", String(params.offset ?? 0));
  return aroFetch<AuditListResponse>(`/api/audit?${qs.toString()}`);
}
